import { useState } from "react";
import { Plus, Trash2, X } from "lucide-react";

const inputCls = "w-full rounded-md border border-zinc-800 bg-[#0b0b0c] px-3 py-2 text-sm text-slate-100 outline-none focus:border-[#C5A059]/60";

export default function KpiModal({ kpis, stages, onChange, onClose }) {
  const [draft, setDraft] = useState({ name: "", stage_id: "" });

  const update = (i, patch) => onChange(kpis.map((k, idx) => (idx === i ? { ...k, ...patch } : k)));
  const remove = (i) => onChange(kpis.filter((_, idx) => idx !== i));
  const add = () => {
    if (!draft.name.trim() || !draft.stage_id) return;
    onChange([...kpis, { name: draft.name.trim(), stage_id: draft.stage_id, is_closing: false }]);
    setDraft({ name: "", stage_id: "" });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" data-testid="kpi-modal" onClick={onClose}>
      <div className="w-full max-w-xl rounded-xl border border-zinc-800 bg-[#111112] p-6 shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="mb-4 flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-slate-50">KPI personalizzati</h2>
            <p className="text-xs text-slate-500">Ogni KPI calcola: ad spend ÷ numero di lead nella fase selezionata. La fase spuntata come <span className="text-[#C5A059]">chiusura</span> definisce cosa conta come <b>contratto chiuso</b> in tutta l'app (trattative chiuse, punteggio venditori, report, Hermes); le fasi successive (es. Consegna) contano anch'esse.</p>
          </div>
          <button onClick={onClose} data-testid="kpi-modal-close" className="text-slate-500 hover:text-slate-200"><X className="h-4 w-4" /></button>
        </div>
        <div className="space-y-3">
          {kpis.map((k, i) => (
            <div key={k.id || i} className="grid grid-cols-[1fr_1fr_auto_auto] items-end gap-3 rounded-lg border border-zinc-800/70 p-3" data-testid={`kpi-row-${i}`}>
              <div>
                <label className="mb-1 block text-xs text-slate-400">Nome</label>
                <input value={k.name} onChange={(e) => update(i, { name: e.target.value })} data-testid={`kpi-name-${i}`} className={inputCls} />
              </div>
              <div>
                <label className="mb-1 block text-xs text-slate-400">Fase</label>
                <select value={k.stage_id} onChange={(e) => update(i, { stage_id: e.target.value })} data-testid={`kpi-stage-${i}`} className={inputCls}>
                  {stages.map((s) => <option key={s.stage_id} value={s.stage_id}>{s.name}</option>)}
                </select>
              </div>
              <label className="flex flex-col items-center gap-1 text-xs text-slate-400">
                Stage di chiusura
                <input type="checkbox" checked={!!k.is_closing} onChange={(e) => update(i, { is_closing: e.target.checked })}
                  data-testid={`kpi-closing-${i}`} className="h-4 w-4 accent-[#C5A059]" />
              </label>
              <button onClick={() => remove(i)} data-testid={`kpi-remove-${i}`} className="mb-1 text-red-400 hover:text-red-300"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
        <div className="mt-5 border-t border-zinc-800/70 pt-4">
          <div className="mb-2 text-xs text-slate-500">Aggiungi nuovo KPI</div>
          <div className="grid grid-cols-[1fr_1fr_auto] items-end gap-3">
            <div>
              <label className="mb-1 block text-xs text-slate-400">Nome</label>
              <input value={draft.name} placeholder="es. Costo per preventivo" onChange={(e) => setDraft((d) => ({ ...d, name: e.target.value }))}
                data-testid="kpi-new-name" className={inputCls} />
            </div>
            <div>
              <label className="mb-1 block text-xs text-slate-400">Fase</label>
              <select value={draft.stage_id} onChange={(e) => setDraft((d) => ({ ...d, stage_id: e.target.value }))} data-testid="kpi-new-stage" className={inputCls}>
                <option value="">Seleziona fase</option>
                {stages.map((s) => <option key={s.stage_id} value={s.stage_id}>{s.name}</option>)}
              </select>
            </div>
            <button onClick={add} disabled={!draft.name.trim() || !draft.stage_id} data-testid="kpi-add-button"
              className="btn-bronze inline-flex items-center gap-1.5 rounded-md px-4 py-2 text-sm disabled:opacity-40"><Plus className="h-4 w-4" /> Aggiungi</button>
          </div>
        </div>
        <div className="mt-5 flex justify-end">
          <button onClick={onClose} data-testid="kpi-modal-done" className="rounded-md border border-zinc-700 px-4 py-2 text-sm text-slate-200 hover:border-[#C5A059]/50">Chiudi</button>
        </div>
      </div>
    </div>
  );
}
